var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scisure-datepicker"
  }, [_c('v-date-picker', {
    key: _vm.datePickerKey,
    ref: "datePicker",
    class: _vm.className,
    attrs: {
      "is-required": _vm.isRequired,
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate,
      "model-config": _vm.modelConfig,
      "masks": _vm.masks,
      "timezone": "utc"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var inputValue = _ref.inputValue,
          inputEvents = _ref.inputEvents;
        return [_vm.label ? _c('label', {
          attrs: {
            "for": _vm.inputValueId
          }
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "input-wrapper"
        }, [_c('input', _vm._g({
          attrs: {
            "id": _vm.inputValueId,
            "name": _vm.inputValueId
          },
          domProps: {
            "value": inputValue
          }
        }, inputEvents)), _vm._v(" "), _vm.useClearButton ? [_vm.localRecordDate ? _c('FilterClearButton', {
          on: {
            "click": _vm.clearInput
          }
        }) : _vm._e()] : _vm._e()], 2)];
      }
    }]),
    model: {
      value: _vm.localRecordDate,
      callback: function ($$v) {
        _vm.localRecordDate = $$v;
      },
      expression: "localRecordDate"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }